import { localStorageKeys } from "../constants/keyName"

export const getToken = () => {
  return localStorage.getItem(localStorageKeys.accessToken) || ''
}

export const setToken = (token: string | null) => {
  localStorage.setItem(localStorageKeys.accessToken, token || '')
}
